import React from 'react';
import logo from "../assets/Logo_1.png";
import { Col, Row, Card, CardBody } from 'reactstrap';

const About = () => {
  return (
    <div className="container my-5">
      <Card className="shadow-lg border-0">



        <Row className="align-items-start mt-4">
          {/* Image on Left (mobile top) */}
          <Col xs={12} md={3} className="d-flex justify-content-center mb-4 mb-md-0">

          </Col>

          {/* Text on Right */}
          <Col xs={12} md={9}>
            <div
              style={{
                backgroundColor: "#77236b",
                padding: "12px 40px",
                borderRadius: "8px",
                border: "1px solid #cdd6f3",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                color: "#fff",
                textAlign: "center",
                width: "100%"  // Ensure full width
              }}
            >
              <h2 className="fw-bold text-white m-0">विश्वविद्यालय के बारे में</h2>
            </div>
          </Col>

        </Row>
        <CardBody className="p-4 p-md-5">
          <Row className="align-items-start">
            {/* Image on Left (mobile top) */}
            <Col xs={12} md={3} className="d-flex justify-content-center mb-4 mb-md-0">
              <img
                src={logo}
                alt="University Logo"
                className="img-fluid rounded shadow-sm"
                style={{
                  height: '200px',
                  width: '200px',
                  objectFit: 'cover',
                }}
              />
            </Col>

            {/* Text on Right */}
            <Col xs={12} md={9}>
              <div style={{ textAlign: 'justify', lineHeight: '1.8', fontSize: '1.05rem' }}>
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp; महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, मून्दड़ी, कैथल, हरियाणा सरकार द्वारा वर्ष 2018 में स्थापित एक राज्य विश्वविद्यालय है।
                  यह कैथल से 8 कि.मी. पूर्व, राज्य की राजधानी चंडीगढ़ से 130 कि.मी., राष्ट्रीय राजधानी नई दिल्ली से 164 कि.मी., पेहोवा से 30 कि.मी. और
                  कुरुक्षेत्र से 45 कि.मी. दूर स्थित है।
                </p>
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp; विश्वविद्यालय वर्तमान में अपने दो अस्थायी परिसरों में संचालित हो रहा है: (1) डॉ. बी.आर. अम्बेडकर राजकीय महाविद्यालय, कैथल और
                  (2) कैथल ढाण्ड मार्ग पर, कैथल से लगभग 10 कि.मी. दूर स्थित है। गांव मून्दड़ी (कैथल) में विश्वविद्यालय के परिसर का निर्माण कार्य प्रगति पर है।
                  इस विश्वविद्यालय का नाम "महर्षि वाल्मीकि" के नाम पर रखा गया है, जो "रामायण" के रचनाकार थे और जिन्हें संस्कृत भाषा के "आदिकवि" के रूप में भी जाना जाता है।
                  ऐसा माना जाता है कि महर्षि वाल्मीकि आश्रम, मून्दड़ी गाँव में स्थित था।
                </p>
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp; विश्वविद्यालय का उद्देश्य आधुनिक विश्व में संस्कृत शिक्षण और अनुसन्धान के माध्यम से संस्कृत और इसके समृद्ध ज्ञान को पुनर्जीवित करना है।
                  इसके अतिरिक्त शास्त्र परम्परा जैसे- वेदों, भारतीय भाषाओं, भारतीय संस्कृति, इतिहास और भारतीय दर्शन सम्बद्ध ज्ञान-विज्ञान का संरक्षण एवं प्रचार-प्रसार करना है।
                </p>
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp; यह विश्वविद्यालय हरियाणा के सभी गुरुकुलों और संस्कृत महाविद्यालयों को साथ लेकर न केवल संस्कृत भाषा बल्कि भारतीय पारम्परिक ज्ञान के संरक्षण
                  और प्रचार के लिए दृढ़ प्रतिज्ञ है। विश्वविद्यालय भारतीय शिक्षा प्रणाली की गुरुकुल परम्परा को सहयोग, समर्थन और पोषण प्रदान करने हेतु भी कटिबद्ध है।
                  विश्वविद्यालय राष्ट्रीय शिक्षा नीति (NEP 2020) को आधुनिक और साथ ही पारम्परिक, मूल्य वर्धित और कौशल-आधारित दोनों पाठ्यक्रमों पर जोर देने के साथ व्यवस्थित विधि से
                  लागू करने के लिए प्रतिबद्ध है।
                </p>
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp; संस्कृत व्याकरण और साहित्य में स्नातक और स्नातकोत्तर के अतिरिक्त, विश्वविद्यालय ने वेद, ज्योतिष, व्याकरण, साहित्य, दर्शन, हिन्दू अध्ययन,
                  धर्मशास्त्र और योग में भी डिग्री पाठ्यक्रम शुरु किया है। योग, कर्मकाण्ड, ज्योतिष एवं वास्तु में डिप्लोमा पाठ्यक्रम भी शुरु किए गए हैं। विश्वविद्यालय का उद्देश्य
                  शिक्षार्थियों को आत्मनिर्भर नागरिक बनाना और भारत को वैदिक काल की तरह विश्वगुरु रूप में पुनः प्रतिष्ठा दिलाना है। अतः मूल्य-आधारित शिक्षा प्रदान करना भी है।
                </p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default About;
